import { getContext } from 'configs/context';
import useOpen from 'hooks/useOpen';
import { toggleHtmlClassName } from 'utils/themes/utils';

/**
 * Applies the active theme on change. In design-system v11 theming is driven by
 * the `dark`/`light` class on <html> (the SCSS foundation supplies the per-theme
 * CSS variables); the v10 `useFoundation({ themes })` runtime injection was
 * removed, so this hook now only toggles that class.
 */
const useThemeChange = () => {
  useOpen(() => {
    return getContext().general.theme.subscribe(
      value => {
        toggleHtmlClassName(value === 'dark');
      },
      { needPrevious: true },
    );
  });
};

export default useThemeChange;
